import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { forwardRef } from 'react';
import { Space } from 'udesk-ui';
import { ContentHeader, RoleTag } from './components';
import XssComponent from 'udesk-react/src/components/xss';
import { replaceLineBreak } from 'src/util/text-replace';

interface TemplateProps {
    item?: any;
    content?: any;
    titleRef?: any;
}

const Template = forwardRef((props: TemplateProps, ref: any) => {
    const { item, content, titleRef } = props;

    const locales = UdeskLocales['current'];

    const { data = {} } = item;

    return (
        <div>
            <ContentHeader>
                <Space>
                    <div style={{ fontWeight: 600 }}>{data.sendUser}</div>
                    <RoleTag sender={data.sender}>
                        {data.sender === 1 || data.sender === '1'
                            ? /* 客户 */ locales.components.ticketTextInfo.index.customer
                            : /* 客服 */ locales.components.ticketTextInfo.index.customerService}
                    </RoleTag>
                </Space>

                <div className="desc" ref={titleRef}>
                    {`${data.createdTime} ${
                        data.eventType === 'create'
                            ? /* 创建了工单 */ UdeskLocales['current'].components.ticketTextInfo
                                  .components.changeRecord.index.workOrderCreated
                            : /* 触发了如下操作 */ UdeskLocales['current'].components.ticketTextInfo
                                  .components.changeRecord.index.triggeredTheFollowingActions
                    }`}
                </div>
            </ContentHeader>

            <div>
                <div ref={ref}>
                    <XssComponent
                        whiteList={Udesk.ui.widgets.xss.whiteLists.email}
                        value={replaceLineBreak(content)}
                    />
                </div>
            </div>
        </div>
    );
});

export default Template;
